import { useState } from 'react';
import {
	Button,
	ToggleButtonGroup,
	ToggleButton,
	Menu,
	MenuItem,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import {
	getStatusFromValue,
	getStyleValue,
	raisedButtonRowStyles,
} from '../Helpers/Helpers.js';

const scoreColorMapping = {
	0: '#2E4AA0',
	1: '#63A100',
	2: '#63A100',
	3: '#63A100',
	4: '#D35D00',
	5: '#AC1B18',
	6: '#AC1B18',
};

import './ScoreInput.css';

export function ScoreInput({ name, score, previousScore, error }) {
	const buttonStyles = raisedButtonRowStyles();
	const buttonSize = '36.5px'; // 36.0 and 37.0 are a pixel off for proper alignment of scoreInput, ActionInput and toggler

	const [selectedScore, setSelectedScore] = useState(score);
	const [anchorEl, setAnchorEl] = useState(null);

	const highScore = selectedScore === '8' || selectedScore === '9';

	const handleMenuItemChange = (event) => {
		setSelectedScore(event.target.dataset.value);
		setAnchorEl(null);
	};

	/**
	 * Render button background colors, including hint (dark grey) for score
	 * selected in previous inspection
	 *
	 * @param  {Number} value
	 * @return {Object}
	 */
	function getBackgroundColor(score) {
		if (selectedScore === score) {
			return scoreColorMapping[score];
		} else if (score === previousScore) {
			return getStyleValue('color-default'); // dark grey
		} else {
			return getStyleValue('color-grey');
		}
	}

	return (
		<div
			className="score-input"
		>
			<div
				className="score-input__score-controls"
			>
				<input
					name={name}
					type="hidden"
					value={getStatusFromValue(selectedScore) || ''}
				/>
				<ToggleButtonGroup
					value={score}
					onChange={(event, newScore) => newScore && setSelectedScore(newScore)}
					exclusive
					style={{ height: buttonSize }}
				>
					{['0', '1', '2', '3', '4', '5', '6'].map((score) => (
						<ToggleButton
							value={score}
							key={score}
							style={{
								...buttonStyles['style'],
								color: score === selectedScore ? getStyleValue('color-white') : getStyleValue('color-text'),
								backgroundColor: getBackgroundColor(score),
								boxShadow: 'var(--shadow-mui-clone)',
								border: 0,
							}}
						>
							{score}
						</ToggleButton>
					))}
				</ToggleButtonGroup>
				<Button
					variant="contained"
					onClick={(event) => setAnchorEl(event.currentTarget)}
					style={{
						...buttonStyles['style'],
						color: highScore ? getStyleValue('color-white') : getStyleValue('color-text'),
						backgroundColor: highScore ? '' : getStyleValue('color-grey'),
						boxShadow: 'var(--shadow-mui-clone)',
						border: 0,
						height: buttonSize,
						width: buttonSize,
					}}
				>
					{highScore ? selectedScore : <MoreVert />}
				</Button>
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={() => setAnchorEl(null)}
				>
					<MenuItem onClick={handleMenuItemChange} data-value="8">
						8. Nader onderzoek nodig
					</MenuItem>
					<MenuItem onClick={handleMenuItemChange} data-value="9">
						9. Niet te inspecteren
					</MenuItem>
				</Menu>
			</div>

			{ error && !selectedScore &&
				<p
					className="score-input__error"
					hidden={!error || selectedScore}
				>
					{ error }
				</p>
			}
		</div>
	);
}
